import { BuyerLanding } from "@/components/BuyerLanding";

export default function HRManager() {
  return (
    <BuyerLanding
      testId="hr-manager-page"
      path="/for/hr-manager"
      seoTitle="Dealership HR Forms, Onboarding & SOPs | Centennial"
      seoDescription="Document incidents the right way, onboard every new hire consistently and keep the audit-ready paper trail that protects the store."
      eyebrow="For HR & Office Managers"
      headline="Run HR that protects the store — documented, consistent, and audit-ready."
      subhead="HR issues happen everywhere, in every kind of shop. Document incidents the right way, onboard every new hire the same way, and keep the paper trail that protects you when it matters."
      toolkitTitle="Your HR toolkit"
      pains={[
        "Terminations challenged because nothing was documented",
        "New hires trained differently by whoever's around that day",
        "Incident reports that are missing, late, or inconsistent",
        "Policies that live in someone's head instead of on file",
      ]}
      packs={[
        { id: "pack_incident", name: "Employee Incident Documentation Pack", desc: "Document write-ups, corrective action, and incidents consistently — so every decision is defensible." },
        { id: "pack_onboarding", name: "New-Hire Onboarding Pack", desc: "Give every new hire the same documented start with checklists, agreements, and first-week structure." },
      ]}
      browseLink={{ label: "Browse all 66 Human Resources forms", to: "/forms?dept=Human%20Resources" }}
    />
  );
}
